__turbopack_context__.v({
  "Embed": "Page-module__8UfuHW__Embed",
  "PostPage": "Page-module__8UfuHW__PostPage",
  "PostPage-content": "Page-module__8UfuHW__PostPage-content",
  "PostPage-hero": "Page-module__8UfuHW__PostPage-hero",
  "PostPage-hero-noBG": "Page-module__8UfuHW__PostPage-hero-noBG",
  "PostPage-hero-text": "Page-module__8UfuHW__PostPage-hero-text",
  "overlay": "Page-module__8UfuHW__overlay",
  "separator--promoted": "Page-module__8UfuHW__separator--promoted",
  "tagsContainer": "Page-module__8UfuHW__tagsContainer",
});
